module.exports = __webpack_public_path__ + "img/coupon_icon.190bac60.png";